import BaseModel from '../core/BaseModel'
// import moment from "moment/moment";
//import gql from 'graphql-tag'
export default class GroupModel extends BaseModel {

    constructor() {
        super({ 
                name: "group",
                tableName: 'group',
                label: "Danh Sách Nhóm Quyền",
                display_key: 'name',
                default_order: { key: 'ordinal', direction: 'asc' } ,
            },
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Bigint",
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            company_name: {
                name: 'company_name',
                type: "String",
                label: 'Công ty',
                width: 15,
                class:"width",
                filter: {type: 'input', match: 'contains'},
                // display: false
            },
            name: {
                name: 'name',
                type: "String",
                label: 'Tên nhóm quyền',
                width: 15,
                class:"width",
                filter: {type: 'input', match: 'contains'},
                // display: false
            },
            group_users: {
                name: 'group_users',
                type: "CustomUrl",
                label: "Đang áp dụng",
                class:"center width_160 common",
            },

            updated_name: {
                refs:"updated_name",
                type: "String",
                label: "Người cập nhật",
                class:"center width_160 common",
            },

            updated_at : {
                name: 'updated_at',
                type: "Datetime",
                label: 'Ngày cập nhật',
                class:"center width_160 common",
            },
        },)
    }

}
